import {
  Card,
  DataDisplay,
  formatPercentTotal,
  Grid,
  pn,
  Stack,
  Typography,
} from "@compass/core";
import { AprEocTabF as AprResponseModel, ModelPropertyBase } from "generated/openApi";

import "moment-timezone";

export const AprEocTabF = (props: {
  data: AprResponseModel | undefined;
  properties: ModelPropertyBase[] | undefined;
}) => {

  const lepField = () => {
    const propertyName = pn<AprResponseModel>("lepStudents");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.lepStudents}
      </DataDisplay>
    );
  };

  return (
    <Card style={{ height: "100%" }}>
      <Stack spacing="sm" style={{ height: "100%" }}>
        <Typography variant="h5">Participants with Limited English Proficiency</Typography>
        <Grid container spacing="lg">
          <Grid item xs={11}>
            {lepField()}
          </Grid>
        </Grid>
      </Stack>
    </Card>
  );
};
